import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, catchError, tap, throwError } from 'rxjs';
import { ENDPOINTS } from '../shared/constants/url.constants';
import { GlobalErrorHandlerService } from '../shared/services/global-error-handler.service';
import { NotificationService } from '../shared/services/notification.service';
import { formatUrl } from '../shared/utils/format-url-util';
import { HttpRequestService } from '../shared/services/http-request.service';

@Injectable({
  providedIn: 'root',
})
export class ClaimsService {
  formData: any = {};
  private selectedLeadId: number | null = null;
  private previousData$ = new BehaviorSubject<any>(null);
  authUpdated = new Subject();
  openPopUp = new Subject();

  constructor(
    private httpClient: HttpRequestService,
    private errorHandler: GlobalErrorHandlerService,
    private notificationService: NotificationService
  ) { }

  getServiceData(programCode: string){
    const url = formatUrl(
      ENDPOINTS.CLAIMS.GET_SERVICE_DATA,
      { programCode }
    );
    return this.httpClient
    .get(url)
    .pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }
}
